var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusRoundedCircle = function SvgPlusRoundedCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.25,
    cy: 8.75,
    r: 8.1,
    stroke: "#D689BC",
    strokeWidth: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 11.25,
    r: 8.1,
    fill: "#BB3A90",
    stroke: "#fff",
    strokeWidth: 1.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.833 11.25h5.834M8.75 14.167V8.333"
  }))));
};
export default SvgPlusRoundedCircle;